import { Controller } from '@hotwired/stimulus';

const GENERATOR_PATH = '/google-sheets-formula-generator';

// Carries the terminal card's prompt to the generator as a query param, which
// the generator page prefills from. Empty prompt just links to the generator.
export default class extends Controller {
  static targets = ['input', 'link'];

  update() {
    const prompt = this.inputTarget.value.trim();
    this.linkTarget.href = prompt
      ? `${GENERATOR_PATH}?prompt=${encodeURIComponent(prompt)}`
      : GENERATOR_PATH;
  }
}
